import React from 'react';
import { GridLegacy as Grid  } from '@mui/material'; //Grid2 is now recommended and has replaced Grid. GridLegacy is the original component.
import {
    DataCard, VisuallyHidden, WidgetTable, WidgetTable_Body,
    WidgetTable_Head, WidgetTable_Header,
    WidgetTable_Row,
    DataCard_EmptyState,
} from 'emerald-ui';
import {
    CargoWidget_Root,
} from './CargoWidget.style';
import { CargoWidgetRow } from '../CargoWidgetRow/CargoWidgetRow';

/**
 * @typedef CargoWidgetDataItem
 * @property {string | number} [id]
 * @property {string} type
 * @property {string} containerNumber
 * @property {string} description
 * @property {string} weight
 * @property {string} trackingNumber
 */

/**
 * @typedef CargoWidgetProps
 * @property {CargoWidgetDataItem[]} data An object containing the data to be rendered.
 */

/** @type {(props: CargoWidgetProps & React.HTMLAttributes<HTMLDivElement>) => JSX.Element} */
export const CargoWidget = (props) => {

    const {
        data = [],
        ...otherProps
    } = props;

    /** @type {React.ReactNode} */
    let content;

    if (data.length) {
        const rows = data.map((dataRow) => (
            <CargoWidgetRow
                dataRow={dataRow}
                key={JSON.stringify(dataRow)}
            />
        ));
        content = (
            <WidgetTable>
                <WidgetTable_Head>
                    <WidgetTable_Row>
                        <VisuallyHidden as={WidgetTable_Header}>Type and Tracking Number</VisuallyHidden>
                        <VisuallyHidden as={WidgetTable_Header}>Description</VisuallyHidden>
                        <VisuallyHidden as={WidgetTable_Header}>Weight</VisuallyHidden>
                    </WidgetTable_Row>
                </WidgetTable_Head>
                <WidgetTable_Body>
                    {rows}
                </WidgetTable_Body>
            </WidgetTable>
        );
    } else {
        content = <DataCard_EmptyState />;
    }

    return (
        <DataCard
            headerText='Cargo'
            style={{ flexGrow: 1 }}
            {...otherProps}
        >
            <Grid
                component={CargoWidget_Root}
                item
                xs={12}
            >
                {content}
            </Grid>
        </DataCard>
    );
};
